import { useTranslation } from "react-i18next";

export default function RenovationStoriesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-paper py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mb-14 md:mb-20">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">
            {t("reno.sectionLabel")}
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] text-ink leading-[1.1] mb-5">
            {t("reno.title")}
            <br />
            <span className="italic font-normal text-ink/70">{t("reno.titleItalic")}</span>
          </h2>
          <p className="text-base text-ink/50 leading-relaxed max-w-xl font-light">
            {t("reno.intro")}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          <div className="border border-hairline overflow-hidden">
            <div className="relative h-64 md:h-80 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Interior%20of%20an%20abandoned%20traditional%20Japanese%20house%20before%20renovation%20with%20peeling%20wallpaper%20exposed%20wooden%20beams%20debris%20on%20the%20floor%20muted%20grayscale%20desaturated%20tones%20documentary%20photography%20no%20people%20no%20on-image%20text%20no%20logos&width=800&height=530&seq=noren-reno-before&orientation=landscape"
                alt="Interior of an abandoned traditional Japanese house before renovation, with peeling wallpaper and exposed beams"
                loading="lazy"
                className="w-full h-full object-cover grayscale"
              />
              <span className="absolute top-4 left-4 bg-ink/80 text-paper text-xs font-semibold uppercase tracking-wider px-3 py-1.5">
                {t("reno.beforeLabel")}
              </span>
            </div>
            <div className="p-5 md:p-6 bg-paper-secondary">
              <p className="text-sm text-ink/50 font-light leading-relaxed">
                {t("reno.beforeDesc")}
              </p>
            </div>
          </div>

          <div className="border border-hairline overflow-hidden">
            <div className="relative h-64 md:h-80 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautifully%20renovated%20traditional%20Japanese%20house%20interior%20with%20polished%20wooden%20floors%20shoji%20screens%20warm%20natural%20light%20minimalist%20furnishing%20warm%20earthy%20tones%20editorial%20architectural%20photography%20no%20people%20no%20on-image%20text%20no%20logos&width=800&height=530&seq=noren-reno-after&orientation=landscape"
                alt="Beautifully renovated traditional Japanese house interior with polished wooden floors and shoji screens"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <span className="absolute top-4 left-4 bg-gold text-ink text-xs font-semibold uppercase tracking-wider px-3 py-1.5">
                {t("reno.afterLabel")}
              </span>
            </div>
            <div className="p-5 md:p-6 bg-paper-secondary">
              <p className="text-sm text-ink/50 font-light leading-relaxed">
                {t("reno.afterDesc")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}